module.exports = "dist/brasil.png?3e4533782e338ed24979bb7bb35ed620";